module.exports = __webpack_public_path__ + "static/img/get-to-the-management-team_1.c2668d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/get-to-the-management-team_1.png
// module id = YmJr
// module chunks = 0